<template>
  <div>
    <template v-if="orderCountList.length">
      <h2 class="text-2xl">Order Stats</h2>
      <el-divider></el-divider>
      <div class="flex flex-wrap">
        <counter-card
          v-bind:title="'View All Orders'"
          :count="totalOrders"
          label="Orders"
          smallLabel="Total"
          identifier=""
          class="mr-6 cursor-pointer"
          @clicked="showOrders"
        ></counter-card>
        <counter-card
          v-bind:title="'View ' + orderCount.displayName + ' Orders'"
          v-for="orderCount in orderCountList"
          :key="orderCount.name"
          :count="orderCount.countOrders"
          :label="orderCount.displayName"
          smallLabel="Orders"
          :identifier="orderCount.name"
          class="mr-6 cursor-pointer"
          @clicked="showOrders"
        ></counter-card>
      </div>
    </template>
    <div class="mt-12 mb-6">
      <h2 class="text-2xl">XQC/Reprint Shipment Requests</h2>
      <el-divider></el-divider>
      <xqc-reprint-table @orderReProcessed="getOrderStatusCount"></xqc-reprint-table>
    </div>
    <div class="mt-12 mb-6">
      <h2 class="text-2xl">Failed/Error Shipment Requests</h2>
      <el-divider></el-divider>
      <failed-shipment-table @orderReProcessed="getOrderStatusCount"></failed-shipment-table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CounterCard from '../../components/counter-card.vue';
import FailedShipmentTable from '../../components/failed-shipment-table.vue';
import XqcReprintTable from '../../components/xqc-reprint-table.vue';
import { orderService } from '../../services';
import router from '../../app-router';
import { OrderCountClientModel } from '../../models/client';

export default defineComponent({
  name: 'Dashboard',
  components: {
    FailedShipmentTable,
    CounterCard,
    XqcReprintTable,
  },
  data: function () {
    return {
      orderCountList: [] as OrderCountClientModel[],
      totalOrders: 0,
    };
  },
  created() {
    this.getOrderStatusCount();
  },
  methods: {
    async getOrderStatusCount() {
      const orderStats = await orderService.getOrderCountList();
      this.orderCountList = orderStats.stats;
      this.totalOrders = orderStats.total;
    },
    showOrders(countDetails) {
      if (countDetails.identifier) {
        router.push({ path: '/tsas/admin/orders', query: { status: countDetails.identifier } });
        return;
      }
      // If identifier do not exist redirect to order page
      router.push({ path: '/tsas/admin/orders' });
    },
  },
});
</script>

<style lang="scss" scoped>
::v-deep(.el-divider) {
  margin-top: 12px;
}
</style>
